import { produce } from 'immer';
import {
    SET_FILE_ID,
    SET_FILES,
    FILE_UPLOAD_COMPLETED,
    FILES_S3,
    FILES_S3_SIGNED_UPLOADED,
    SET_CLEAR_FILES
} from "../actions/Files";
import { uploadSpeed } from "../utils/basic";

const initialState = {
    files: {},
    fileUploadCompleted: false,
    filesS3: [],
    fileId: false

};

const fileReducer = produce((draft = initialState, action) => {
    const { type, payload } = action;
    switch (type) {

        case SET_FILE_ID: {
            draft.fileId = action.fileId;
            return draft;
        }

        case SET_FILES: {
            draft.files = action.files;
            return draft;
        }

        case FILE_UPLOAD_COMPLETED: {
            draft.fileUploadCompleted = payload;
            return draft;
        }

        case FILES_S3: {
            draft.filesS3.push(payload);
            return draft;
        }

        case FILES_S3_SIGNED_UPLOADED: {
            var files = payload;
            const fileToUpdate = draft.filesS3.find(f => f.fileId ===
                files[action.thisFileIndex].fileId);

            fileToUpdate.parts[action.thisPartIndex].uploaded = action.progressEvent.loaded;

            const totalUploaded = fileToUpdate.parts.reduce((acc, part) => {
                return acc + part.uploaded;
            }, 0);

            fileToUpdate.percent = action.progressEvent.loaded === action.progressEvent.total ? 100 : Math.ceil((totalUploaded / fileToUpdate.size) * 100);

            fileToUpdate.speed = uploadSpeed(
                //moment(action.progressEvent.timestamp).unix(),
                Math.floor(new Date(action.progressEvent.timestamp).getTime() / 1000),
                fileToUpdate.startedAt,
                fileToUpdate.size,
                totalUploaded
            );

            return draft;
        }

        case SET_CLEAR_FILES: {

            // eslint-disable-next-line no-unused-expressions
            draft.fileId = false,
                draft.files = {},
                draft.filesS3 = [],
                draft.fileUploadCompleted = false
            return draft;
        }

        default: {
            return draft;
        }
    }

});

export default fileReducer;
